module.exports = __webpack_public_path__ + "img/sv1.9b91469f.svg";